import React, { Component } from 'react'
import { GridTable } from '../Sidebar/SidebarStyles';
import { Box, Button, Chip, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import { Refresh, SimCardDownload, FileUpload } from '@mui/icons-material';
import { getStatusColor, newstatusValueArray } from './ApiCommonService';
import { GenerateAMSUrl } from '../ApiSevices/UserMasterApis';

interface IProps {
    displaysidebar: boolean;
}

interface IState {
    loading: boolean;
    JobId: string;
    Email: string;
    isValidInputs: boolean;
    tableData: any[];
}

export default class GenerateAmsUrl extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            JobId: '',
            Email: '',
            isValidInputs: false,
            tableData: [],
        };
    }

    handleInputChanges(e: React.ChangeEvent<HTMLInputElement>, key: string) {
        this.setState((prevState) => ({ ...prevState, [key]: e.target.value }));
        this.validateInputs();
    }

    isValidEmail(email: string) {
        const regex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email.trim());
    };

    convertToKeyValueArray(obj: Record<string, any>) {
        return Object.entries(obj).map(([key, value]) => ({
            key,
            value
        }));
    };

    handleGenerateUrl = async () => {
        this.setState({ loading: true });
        try {
            const response = await GenerateAMSUrl(this.state.JobId, this.state.Email);
            if (response) {
                this.setState({ tableData: this.convertToKeyValueArray(response) });
            }
        } catch (error) {
            console.error("Error generating AMS URL:", error);
        } finally {
            this.setState({ loading: false });
        }
    }

    validateInputs = () => {
        const { JobId, Email } = this.state;
        const isJobIdValid = JobId.trim() !== '';
        const isEmailValid = this.isValidEmail(Email);
        this.setState({ isValidInputs: isJobIdValid && isEmailValid });
    }

    render() {
        const { loading, isValidInputs, tableData, Email, JobId } = this.state;
        return (
            <div style={{ fontSize: "12px" }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable sx={{ height: '90vh' }} displaysidebar={this.props.displaysidebar}>
                    <Grid container direction="column" spacing={0} sx={{ height: '100%' }}>
                        <Grid item sx={{ height: '7vh' }}>
                            <Grid container spacing={0}>
                                <Grid item lg={11.5} sm={11}>
                                    <div style={{ display: 'flex', gap: '10px' }}>

                                        <TextField
                                            size="small"
                                            placeholder="Job ID"
                                            value={JobId}
                                            onChange={(event: any) => this.handleInputChanges(event, 'JobId')}
                                            onKeyUp={(event: any) => this.handleInputChanges(event, 'JobId')}
                                            sx={{
                                                '& .MuiInputBase-input::placeholder': {
                                                    fontSize: '11px',
                                                },
                                                '& .MuiInputBase-input': {
                                                    fontSize: '11px',
                                                },
                                                width: 200,
                                            }}
                                        />

                                        <TextField
                                            size="small"
                                            placeholder="Email"
                                            value={Email}
                                            onChange={(event: any) => this.handleInputChanges(event, 'Email')}
                                            onKeyUp={(event: any) => this.handleInputChanges(event, 'Email')}
                                            sx={{
                                                '& .MuiInputBase-input::placeholder': {
                                                    fontSize: '11px',
                                                },
                                                '& .MuiInputBase-input': {
                                                    fontSize: '11px',
                                                },
                                                width: 200,
                                            }}
                                        />
                                        <Tooltip disableHoverListener={!isValidInputs} title="Click here to generate AMS URL" >
                                            <Button
                                                variant="contained"
                                                size="small"
                                                sx={{ fontSize: '10px', backgroundColor: '#501e75' }}
                                                onClick={this.handleGenerateUrl}
                                                disabled={!isValidInputs}
                                            >
                                                Generate URL
                                            </Button>
                                        </Tooltip>
                                    </div>
                                </Grid>
                                <Grid item lg={.5} sm={1} marginTop={0.5}>
                                    <Tooltip title={"Click here to refresh the table"}>
                                        <span>
                                            <Refresh
                                                sx={{ cursor: "pointer", color: "blue", boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px', border: '0.1px solid black' }}
                                                onClick={() => {
                                                    this.setState({
                                                        isValidInputs: false,
                                                        Email: '',
                                                        JobId: '',
                                                        tableData: []
                                                    });
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item sx={{ height: '23vh' }}>
                            <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #edebeb' }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>S.No</TableCell>
                                            <TableCell>Key </TableCell>
                                            <TableCell>Value </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody style={tableData?.length === 0 ? { height: '150px', alignItems: 'center', justifyContent: 'center' } : {}}>
                                        {tableData?.length === 0 ? (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={3}
                                                    sx={{
                                                        textAlign: "center",
                                                        height: "150px",
                                                        fontSize: "12px",
                                                        padding: 0,
                                                    }}
                                                >
                                                    No records to display
                                                </TableCell>
                                            </TableRow>

                                        ) : (
                                            tableData?.map((row, index) => {
                                                return (
                                                    <TableRow hover key={row.key + index}>
                                                        <TableCell>
                                                            {index + 1}
                                                        </TableCell>

                                                        <TableCell>
                                                            {row.key}
                                                        </TableCell>

                                                        <TableCell>
                                                            {row.value}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        )}
                                    </TableBody>
                                </Table>
                            </Paper>
                        </Grid>
                    </Grid>

                </GridTable >
            </div >
        );
    }
}
